<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12 sm6 offset-sm3>

        <v-alert  :value="true"  v-if="error != null" type="error" >{{ error.message }}</v-alert>

        <v-layout justify-center column>
          <template v-if="ready">
            <v-form ref="form" v-model="valid" @submit="updateUser">

              <v-layout row>
                <v-flex xs12>
                  <p class="notice">We'd love to keep in touch. Please let us know which communications you'd like to receive. You can update your preferences at any time from your account.</p>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex xs12 pb-0>
                  <v-switch
                    v-model="optInClub"
                    color="#5bb57c"
                  >
                    <template v-slot:label>
                      <div>
                        <strong>Stoke City Football Club</strong>
                        <p class="switch-description">The latest news, ticketing, retail updates and behind the scenes content from Stoke City Football Club, Stoke City Foundation, Stoke City Women and special offers we share from our partners.</p>
                      </div>
                    </template>
                  </v-switch>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex xs12 py-0>
                  <v-switch
                    v-model="optInEvents"
                    color="#5bb57c"
                  >
                    <template v-slot:label>
                      <div>
                        <strong>Events</strong>
                        <p class="switch-description">Keep up to date with what's on at the bet365 Stadium on non-matchdays (e.g. concerts, dinners, conferences and other entertainment events).</p>
                      </div>
                    </template>
                  </v-switch>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex xs12>
                  <p class="notice">You can access our preference centre at any time to opt-out of communications and control how we use your data.</p>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex xs12 pt-0 pb-1>
                  <v-switch
                    id="termsSwitch"
                    :label="`I have read and understood the Club's privacy policy`"
                    v-model="termsAgree"
                    :rules="termsAgreeRules"
                    color="#5bb57c"
                  ></v-switch>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex xs12 pt-0 pb-3>
                  <p><a class="privacy-policy text-button" href="https://www.stokecityfc.com/privacypolicy" target="_blank">https://www.stokecityfc.com/privacypolicy</a></p>
                </v-flex>
              </v-layout>

              <v-layout row align-center mx-1 py-0>
                <v-spacer />
                <button type="submit" class="button" :disabled="!valid || loading">{{ loading ? 'Saving...' : 'Complete Registration' }}</button>
              </v-layout>

            </v-form>
          </template>

          <template v-else>
            <div class="text-xs-center">
              <v-progress-circular
              :size="50"
              color="accent"
              indeterminate
              ></v-progress-circular>
            </div>
          </template>
        </v-layout>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'PostSocialRegistration',
  data () {

    return {
      ready: false,
      valid: true,
      termsAgreeRules: [
        v => !!v || 'You must agree to continue'
      ],
      optInClub: true,
      optInEvents: true,
      termsAgree: false,
      error: null,
      loading: false
    }
  },
  created () {
    // Someone arriving here without a session can still see the form (the app
    // only redirects authenticated users), so don't wait on an attribute
    // lookup that will never resolve.
    if (this.$getAuthenticatedUser() == null) {
      this.ready = true
      return
    }

    // A brand new social sign-up has no preferences stored, so the toggles
    // default to opted in, matching the email registration form. Where a
    // preference already exists we honour it rather than quietly opting the
    // user back in to something they had previously turned off.
    this.$getCurrentUserAttributes().subscribe((userData) => {
      this.optInClub = this.storedPreference(userData['custom:club_email'])
      this.optInEvents = this.storedPreference(userData['custom:events_email'])
      this.ready = true
    },
    (err)=> {
      console.log('Unable to load existing preferences, showing defaults.')
      this.ready = true
    });
  },
  methods: {
    // an unset attribute means the user has never been asked - opt in by
    // default. Anything else is an explicit choice we should reflect.
    storedPreference (value) {
      if (value === undefined || value === null || value === '') {
        return true
      }
      return value === 'true'
    },
    updateUser (e) {
        e.preventDefault()
        // an update is already in flight - set synchronously so that repeated
        // clicks are blocked before Vue has re-rendered the disabled button
        if (this.loading) {
          return
        }
        // guard against submission by keyboard, which bypasses the disabled button
        if (!this.$refs.form.validate()) {
          return
        }
        this.loading = true

        var optInClub = this.optInClub.toString();
        var optInEvents = this.optInEvents.toString();
        var termsAgree = this.termsAgree.toString();

        var attributesList = {
            "custom:club_email": optInClub,
            "custom:club_sms": optInClub,
            "custom:womens_email": optInClub,
            "custom:womens_sms": optInClub,
            "custom:foundation_email": optInClub,
            "custom:foundation_sms": optInClub,
            "custom:partner_email": optInClub,
            "custom:partner_sms": optInClub,
            "custom:events_email": optInEvents,
            "custom:events_sms": optInEvents,
            "custom:privacy_accepted": termsAgree
        }

        this.$updateAttributes(attributesList).subscribe((response) => {
            console.log("update successful")
            if (localStorage.completeRegistrationRedirect){
              var redirect = localStorage.completeRegistrationRedirect
              console.log('redirecting to ' + localStorage.completeRegistrationRedirect)
              localStorage.removeItem('completeRegistrationRedirect')
              window.location = redirect
            } else {
              this.$router.push("/confirm");
            }
        },
        (err)=> {
            //if we get an UnkownError it is more than likely because the user has a status of 'FORCE_CHANGE_PASSWORD' in AWS Cognito
            console.log(err.message)
            this.error = err
            // let them correct the problem and try again
            this.loading = false
        });
    }
  }
}
</script>

<style>
  .password-notice {
    margin: 0 0 20px;
    padding: 0 0 40px;
    color: #878787;
    font-size: 15px;
    line-height: 22px;
    border-bottom: 1px solid #eee;
  }

  
  .v-input--switch__track.theme--light.error--text {
    color: rgba(0,0,0,0.38) !important;
  }
  .v-input--selection-controls__ripple.error--text{
    color: #fff !important;
  }
  .v-input--switch__thumb.theme--light.error--text{
    color:#fafafa !important;
  }
  .switch-description {
    margin: 4px 0 0;
    font-size: 13px;
    line-height: 18px;
    color: #666;
  }
</style>
